import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';

export const getIngredientsQuery = gql`
  query ingredients($breweryId: Int!) {
    ingredients(breweryId: $breweryId) {
      id
      name
      type
      measurementType
    }
  }
`;

const IngredientOptions = ({ brewery }) => (
  <Query query={getIngredientsQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <option>...</option>;
      }

      if (error) {
        return <option>Sorry, there was an error getting the ingredients</option>;
      }

      return (
        <Fragment>
          <option>Select an ingredient</option>
          {data.ingredients.map(ingredient => (
            <option key={ingredient.id} value={ingredient.id}>
              {ingredient.name}
            </option>
          ))}
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(IngredientOptions);



// WEBPACK FOOTER //
// ./src/containers/ingredientOptions/ingredientOptions.jsx